import {http} from '../util/http'
import {API_KOTLIN_DOMAIN} from '../config'
import headers from './employeeSystemHeader'

// 新增套餐
export const postNewPackage = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-table/prepaid`,
    method: 'post',
    data,
  })
}

// 修改套餐
export const postEditPackage = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-table/prepaid`,
    method: 'put',
    data,
  })
}

// 删除套餐
export const deleteEditPackage = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-table/prepaid`,
    method: 'put',
    data,
  })
}

// 获取套餐信息详情
export const fetchPackageDetail = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-table/prepaid/detail`,
    params,
  })
}

//获取套餐允许预订使用
export const fetchPackageAllowReserve = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/reservation/prepaid/enable`,
    params,
  })
}

export const updatePackageAllowReserve = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/reservation/prepaid/enable`,
    method: 'post',
    data,
  })
}





// WEBPACK FOOTER //
// ./src/api/package.js